import React, { useEffect } from 'react'

import { useStore } from 'reto'
import { useParams,useLocation } from 'react-router-dom'
import { Pannellum } from "pannellum-react";

import AppStorages from '../../Storages/AppStorage'
import { getImageUrl } from '../../Interface/request'

const Share = () => {

  const params = useParams()
  const location = useLocation()
  // 获取全景图片的地址，并传递过去
  const imgId = location.search.split('?imgId=')[1]
  const { OnReady, ImageUrl, setImageUrl } = useStore(AppStorages)

  useEffect(() => {
    OnReady && initialize()
  }, [OnReady])

  const initialize = () => {

    // 请求接口，赋值
    // imgId && getImageUrl({ id: imgId }).then((res) => {
    //   console.log(res)
    //   setImageUrl(baseUrl + res.data.imgUrl)
    // })
    console.log('传递的Location', location);
    console.log('传递的imgId', imgId);

    //直接赋值
    // setImageUrl("http://3d.zjdxzht.com/uploads/20230814/08494b6377cc725c6646bef68e1f7b44.jpg")
    setImageUrl(imgId)

  }

  return <>
    <div>
      <Pannellum
        width="100%"
        height="100vh"
        image={ImageUrl}
        pitch={10}
        yaw={180}
        hfov={110}
        autoLoad
        onLoad={() => {
          console.log("panorama loaded");
        }}
      >
      </Pannellum>
    </div>
  </>
}

export default Share